export const getPlanForAnalyticsCl = (deductible) => {
  return {
    precio: deductible.quotePrice.price.price,
    cobertura: deductible.quotePrice.coverage.title,
    cobertura_id: deductible.quotePrice.coverage.id,
  };
};
